import { Layout } from "components";

import { CircularProgress, Grid2 } from "@mui/material";

import { useBookingById } from "../../api/hooks/useBookingById/useBookingById.ts";
import BookingInfo from "../../components/Modules/BookingInfo/BookingInfo.tsx";

const BookingDetails = () => {

  const { data, isFetching } = useBookingById();

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  if (!data) return null;

  return (
    <Layout>
      <BookingInfo booking={data} />
    </Layout>
  );
};

export default BookingDetails;
